export const hasPermission = (permissions: string[], permission: string) =>
  permissions.includes(permission);
